const TYPE = "tipoPedido";

const tipoPedidoModule = {
  findAll: async (dbConnection) => {
    let tiposPedido = [];
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
      },
    });

    if (result.docs.length) {
      tiposPedido = result.docs;
    }

    return tiposPedido;
  },
  findByIdIntegracao: async (dbConnection, idIntegracao) => {
    let tipoPedido = null;
    let result = await dbConnection.find({
      selector: {
        type: { $eq: TYPE },
        status: { $eq: "A" },
        idIntegracao: { $eq: idIntegracao},
      },
    });

    if (result.docs.length) {
      tipoPedido = result.docs[0];
    }

    return tipoPedido;
  },
};

export default tipoPedidoModule;
